//Date related importes
import dayjs from "dayjs";
import {
  DatePicker,
  LocalizationProvider,
  DateTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Snackbar,
  Alert,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState, useRef } from "react";
import ConfirmationDialog from "../../common/ConfirmationDialog";
import { AdminPreferencesService } from "../../services/adminPref.Service";
import moment from "moment";
import EditIcon from "@mui/icons-material/Edit";

const useStyles = makeStyles({
  root: {
    "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus":
      {
        outline: "none",
      },
  },
});

const today = moment();

export default function VotingTimelineSetup(props) {
  const classes = useStyles();
  const leagueOriginalData = useRef([]);
  const combineOriginalData = useRef([]);
  const { user } = props;
  const [open, setConfirmationBoxOpen] = useState(false);
  const [eventType, setEventType] = useState("");
  const [combineYear, setCombineYear] = useState("");
  const [eventTypeError, setEventTypeError] = useState(false);
  const [combineYearError, setCombineYearError] = useState(false);
  const [startDateTimeError, setStartDateTimeError] = useState(false);
  const [endDateTimeError, setEndDateTimeError] = useState(false);
  const [startDateTime, setStartDateTime] = useState(null);
  const [endDateTime, setEndDateTime] = useState(null);
  const [leagueDropdownData, setLeagueDropdownData] = useState([]);
  const [combineYearDropdownData, setCombineYearDropdownData] = useState([]);
  const [votingTimelineSummary, setGridData] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState("warning");
  const [alertMessage, setAlertMessage] = useState("");
  const [startDateTimeErrorColor, setStartDateTimeErrorColor] = useState("");
  const [endDateTimeErrorColor, setEndDateTimeErrorColor] = useState("");
  const [dateTimeValid, setDateTimeValid] = useState(true);
  const [columnFlex, setColumnFlex] = useState(
    window.innerWidth >= 768 ? 1 : "none"
  );

  useEffect(() => {
    AdminPreferencesService.getLeagueNames().then((response) => {
      response.data.forEach((item) => {
        leagueOriginalData.current.push({
          leagueId: item.leagueId,
          eventName: item.eventName,
        });
      });
      setLeagueDropdownData(leagueOriginalData.current);
    });
    AdminPreferencesService.getCombineNames().then((response) => {
      response.data.forEach((item) => {
        combineOriginalData.current.push({
          leagueId: item.leagueId,
          EventId: item.eventId,
          combineYear: item.combineYear,
        });
      });
      setCombineYearDropdownData(combineOriginalData.current);
    });
    AdminPreferencesService.getAdminPrefBallotVotingDateTimeDetails().then(
      (response) => {
        let data = [];
        response.data.forEach((item) => {
          data.push({
            id: item.id,
            leagueId: item.leagueId,
            eventName: item.eventName,
            EventId: item.eventId,
            votingStartDatetime: item.votingStartDatetime,
            votingEndDatetime: item.votingEndDatetime,
            lastUpdatedDate: item.modifiedDate,
          });
        });
        setGridData(data);
      }
    );
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  const onResize = () => {
    setColumnFlex(window.innerWidth >= 768 ? 1 : "none");
  };

  const handleRowEditClick = (id) => {
    const editData = votingTimelineSummary.filter((elem) => elem.id === id);
    // console.log("votingTimelineSummary",votingTimelineSummary)
    handleEventTypeChange(editData[0].leagueId);
    handleCombineYearChange(editData[0].EventId);

    //Notes: to fix datetime error alert issue compared the provided start date and end date
    // handleStartDateTimeChange(dayjs(editData[0].votingStartDatetime));
    // handleEndDateTimeChange(dayjs(editData[0].votingEndDatetime));
    checkIsValidDateTime(
      dayjs(editData[0].votingStartDatetime),
      dayjs(editData[0].votingEndDatetime)
    );
  };

  const checkIsValidDateTime = (dStartDateTime, dEndDateTime) => {
    if (dStartDateTime !== null && dEndDateTime !== null) {
      //Check start date validation
      if (dStartDateTime.isValid()) {
        if (dStartDateTime.isAfter(dEndDateTime)) {
          setAlert(true);
          setAlertType("warning");
          setAlertMessage(
            "Start Date Time cannot be greater than End Date Time"
          );
          setStartDateTimeError(true);
          setStartDateTimeErrorColor("#d32f2f");
          return;
        } else {
          setStartDateTime(dayjs(dStartDateTime));
          setStartDateTimeError(false);
          setStartDateTimeErrorColor("");
        }
      }

      //Check End date validation
      if (dEndDateTime.isValid()) {
        if (dEndDateTime.isBefore(dStartDateTime)) {
          setAlert(true);
          setAlertType("warning");
          setAlertMessage("End Date Time cannot be less than Start Date Time");
          setEndDateTimeError(true);
          setEndDateTimeErrorColor("#d32f2f");
          return;
        } else {
          setEndDateTime(dayjs(dEndDateTime));
          setEndDateTimeError(false);
          setEndDateTimeErrorColor("");
        }
      }
    } else {
      setAlert(true);
      setAlertType("error");
      setAlertMessage("error while fetching start date and end date.");
    }
  };

  const handleEventTypeChange = (value) => {
    setEventType(value);
    setCombineYear("");
    AdminPreferencesService.getCombineNamesID(value).then((response) => {
      // console.log("Combine vlaue",response.data)

      setCombineYearDropdownData(response.data);
    });
    setEventTypeError(false);
  };

  const handleCombineYearChange = (value) => {
    setCombineYear(value);
    setCombineYearError(false);
  };

  const handleStartDateTimeChange = (newValue) => {
    if (newValue !== null) {
      if (newValue.isValid()) {
        // if (newValue.isBefore(moment())) {
        //   setAlert(true);
        //   setAlertType("warning");
        //   setAlertMessage("Date Time input values cannot be in the past");
        //   setStartDateTimeError(true);
        //   setStartDateTimeErrorColor("#d32f2f");
        //   setStartDateTime(null);
        // } else
        if (newValue.isAfter(endDateTime)) {
          setAlert(true);
          setAlertType("warning");
          setAlertMessage(
            "Start Date Time cannot be greater than End Date Time"
          );
          setStartDateTimeError(true);
          setStartDateTimeErrorColor("#d32f2f");
          return;
        } else {
          setStartDateTime(dayjs(newValue));
          setStartDateTimeError(false);
          setStartDateTimeErrorColor("");
        }
      } else {
        setStartDateTime(dayjs(newValue));
        setStartDateTimeError(true);
        setStartDateTimeErrorColor("#d32f2f");
      }
    } else {
      setStartDateTime(dayjs(newValue));
    }
  };

  const handleEndDateTimeChange = (newValue) => {
    if (newValue !== null) {
      if (newValue.isValid()) {
        // if (newValue.isBefore(moment())) {
        //   setAlert(true);
        //   setAlertType("warning");
        //   setAlertMessage("Date Time input values cannot be in the past");
        //   setEndDateTimeError(true);
        //   setEndDateTimeErrorColor("#d32f2f");
        //   setEndDateTime(null);
        // } else
        if (newValue.isBefore(startDateTime)) {
          setAlert(true);
          setAlertType("warning");
          setAlertMessage("End Date Time cannot be less than Start Date Time");
          setEndDateTimeError(true);
          setEndDateTimeErrorColor("#d32f2f");
          return;
        } else {
          setEndDateTime(dayjs(newValue));
          setEndDateTimeError(false);
          setEndDateTimeErrorColor("");
        }
      } else {
        setEndDateTime(dayjs(newValue));
        setEndDateTimeError(true);
        setEndDateTimeErrorColor("#d32f2f");
      }
    } else {
      setEndDateTime(dayjs(newValue));
    }
  };

  const validateForm = () => {
    let isFormValid = false;
    if (
      eventType &&
      combineYear &&
      startDateTime !== null &&
      endDateTime !== null &&
      startDateTime.isValid() &&
      endDateTime.isValid()
    ) {
      isFormValid = true;
    }

    if (!isFormValid) {
      if (
        (startDateTime && !startDateTime.isValid()) ||
        (endDateTime && !endDateTime.isValid())
      ) {
        setAlert(true);
        setAlertType("warning");
        setAlertMessage("Date Time input values are invalid");
      } else {
        setAlert(true);
        setAlertType("warning");
        setAlertMessage("All input fields are mandatory");
      }
    }

    if (eventType) {
      setEventTypeError(false);
    } else {
      setEventTypeError(true);
    }
    if (combineYear) {
      setCombineYearError(false);
    } else {
      setCombineYearError(true);
    }
    if (startDateTime !== null && startDateTime.isValid()) {
      setStartDateTimeError(false);
      setStartDateTimeErrorColor("");
    } else {
      setStartDateTimeError(true);
      setStartDateTimeErrorColor("#d32f2f");
    }
    if (endDateTime !== null && endDateTime.isValid()) {
      setEndDateTimeError(false);
      setEndDateTimeErrorColor("");
    } else {
      setEndDateTimeError(true);
      setEndDateTimeErrorColor("#d32f2f");
    }
    return isFormValid;
  };

  const handleAlertClose = (e) => {
    setAlert(false);
  };

  const handleConfirmationBoxClose = (newValue) => {
    setConfirmationBoxOpen(false);
  };

  const handleSubmitAction = () => {
    const isFormValid = validateForm();
    if (isFormValid) {
      setConfirmationBoxOpen(true);
    }
  };

  const submitVotingTimelineSetup = (e) => {
    const isUpdate = votingTimelineSummary.filter(
      (elem) => elem.leagueId === eventType && elem.EventId === combineYear
    ).length
      ? true
      : false;
    const formObj = {
      id: 0,
      eventId: combineYear,
      userBy: user.loginID,
      votingStartDatetime: startDateTime.format("MM/DD/YYYY HH:mm:ss"),
      votingEndDatetime: endDateTime.format("MM/DD/YYYY HH:mm:ss"),
    };
    AdminPreferencesService.insertUpdateAdminPrefBallotVotingDateTime(
      formObj
    ).then((response) => {
      setConfirmationBoxOpen(false);
      setAlert(true);
      setAlertType("success");
      if (isUpdate) {
        setAlertMessage("Record updated successfully");
      } else {
        setAlertMessage("Record created successfully");
      }
      setEventType("");
      setCombineYear("");
      setStartDateTime(null);
      setEndDateTime(null);
      AdminPreferencesService.getAdminPrefBallotVotingDateTimeDetails().then(
        (response) => {
          let data = [];
          response.data.forEach((item) => {
            data.push({
              id: item.id,
              leagueId: item.leagueId,
              eventName: item.eventName,
              EventId: item.eventId,
              votingStartDatetime: item.votingStartDatetime,
              votingEndDatetime: item.votingEndDatetime,
              lastUpdatedDate: item.modifiedDate,
            });
          });
          setGridData(data);
        }
      );
    });
  };

  return (
    <Box mt={2}>
      <Grid container rowSpacing={4} spacing={3}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <FormControl size="small" error={eventTypeError} fullWidth>
              <InputLabel className={props.classes.root}>Event Type</InputLabel>
              <Select
                value={eventType}
                label="Event Type"
                onChange={(e) => {
                  handleEventTypeChange(e.target.value);
                }}
              >
                {leagueDropdownData.map((elem, i) => {
                  return (
                    <MenuItem key={i} value={elem.leagueId}>
                      {elem.eventName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={2} md={2} sm={6} xs={12}>
            <FormControl size="small" error={combineYearError} fullWidth>
              <InputLabel className={props.classes.root}>Combine ID</InputLabel>
              <Select
                value={combineYear}
                label="Combine ID *"
                onChange={(e) => handleCombineYearChange(e.target.value)}
              >
                {combineYearDropdownData.map((elem, i) => {
                  return (
                    <MenuItem key={i} value={elem.eventId}>
                      {elem.eventId}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <FormControl size="small" fullWidth className="date-time-picker">
              <DateTimePicker
                clearable
                //minDateTime={today}
                label="Start Date Time"
                value={startDateTime}
                onChange={handleStartDateTimeChange}
                slotProps={{ textField: { size: "small" } }}
                InputProps={{
                  style: {
                    maxHeight: 40,
                  },
                  error: startDateTimeError,
                }}
                renderInput={(params) => (
                  <TextField
                    InputLabelProps={{
                      style: { color: startDateTimeErrorColor },
                      error: startDateTimeError,
                    }}
                    {...params}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <FormControl size="small" fullWidth className="date-time-picker">
              <DateTimePicker
                clearable
                // minDateTime={today}
                label="End Date Time"
                value={endDateTime}
                onChange={handleEndDateTimeChange}
                slotProps={{ textField: { size: "small" } }}
                InputProps={{
                  style: {
                    maxHeight: 40,
                  },
                  error: endDateTimeError,
                }}
                renderInput={(params) => (
                  <TextField
                    InputLabelProps={{
                      style: { color: endDateTimeErrorColor },
                      error: endDateTimeError,
                    }}
                    {...params}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs="auto">
            <FormControl sx={{ marginTop: "4px" }}>
              <Button
                size="small"
                variant="contained"
                onClick={handleSubmitAction}
              >
                Save
              </Button>
              <ConfirmationDialog
                keepMounted
                open={open}
                onClose={handleConfirmationBoxClose}
                onSubmit={submitVotingTimelineSetup}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <DataGrid
              className={classes.root}
              pageSize={10}
              rowHeight={38}
              headerHeight={35}
              autoHeight={true}
              rows={votingTimelineSummary}
              columns={[
                { field: "id", hide: true, flex: 1 },
                { field: "leagueId", hide: true, flex: 1 },
                {
                  field: "eventName",
                  headerName: "Event Type",
                  width: 150,
                  flex: columnFlex,
                },
                {
                  field: "EventId",
                  headerName: "Combine ID",
                  width: 150,
                  flex: columnFlex,
                },
                {
                  field: "votingStartDatetime",
                  headerName: "Start Date Time",
                  width: 150,
                  flex: columnFlex,
                },
                {
                  field: "votingEndDatetime",
                  headerName: "End Date Time",
                  width: 150,
                  flex: columnFlex,
                },
                {
                  field: "lastUpdatedDate",
                  headerName: "Last Updated Date",
                  width: 150,
                  flex: columnFlex,
                },
                {
                  field: "actions",
                  type: "actions",
                  headerName: "Action",
                  width: 100,
                  cellClassName: "actions",
                  getActions: ({ id }) => {
                    return [
                      <div title="Edit">
                        <EditIcon
                          sx={{
                            marginTop: "8px",

                            fontSize: "1.5rem",
                            cursor: "pointer",
                            color: "#1d428a",
                          }}
                          className="action-edit-button"
                          onClick={() => {
                            handleRowEditClick(id);
                          }}
                        />
                      </div>,
                    ];
                  },
                },
              ]}
              disableSelectionOnClick
              disableColumnSelector
              getCellClassName={(params) => {
                if (params.field !== "actions") {
                  return `admin-pref-grid-cells`;
                }
              }}
              components={{
                NoRowsOverlay: () => (
                  <Box
                    sx={{
                      position: "absolute",
                      marginTop: "82px",
                      marginLeft: "45%",
                    }}
                  >
                    No Rows
                  </Box>
                ),
                NoResultsOverlay: () => (
                  <Box
                    sx={{
                      position: "absolute",
                      marginTop: "82px",
                      marginLeft: "45%",
                    }}
                  >
                    No Results Found
                  </Box>
                ),
              }}
            />
          </Grid>
          <Snackbar
            open={alert}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            autoHideDuration={3000}
            onClose={handleAlertClose}
          >
            <Alert
              onClose={handleAlertClose}
              severity={alertType}
              sx={{ width: "100%" }}
            >
              {alertMessage}
            </Alert>
          </Snackbar>
        </LocalizationProvider>
      </Grid>
    </Box>
  );
}
